import React, { useState } from 'react';
import { Box, Typography, Grid } from '@mui/material';
import { useNavigate } from 'react-router-dom';
import { authService } from '../services/api';
import { HeaderIOS, IOS } from './shared/MenuLayout';

const PLANES = [
  { anios:1, antes:354, ahora:349,  badge:null },
  { anios:2, antes:590, ahora:593, badge:'MÁS POPULAR' },
  { anios:3, antes:826, ahora:837.5,  badge:'MEJOR PRECIO' },
];

const REQUISITOS = [
  'DNI y/o CE actual y vigente.',
  'Ficha RUC con código QR (no mayor a 7 días de antigüedad).',
  'Vigencia de poder / copia literal del Representante Legal con código QR (no mayor a 3 meses).',
  'Validación de identidad.',
];

const CARACTERISTICAS = [
  'Certificado de Agente Automatizado para facturación electrónica.',
  'Emitido por Entidad de Certificación en TSL de INDECOPI.',
  'Firma documentos XML (UBL).',
  'Estándar X.509 v3, SHA2 y RSA de 2048 bits.',
  'Formatos .PFX, .P12 y .CER. Compatible con FACTURADOR SUNAT.',
  'Compatible con sistemas propios, terceros y PSE.',
  'Un solo certificado para todos los comprobantes electrónicos.',
];

const SectionCard = ({children,sx={}}) => (
  <Box sx={{bgcolor:IOS.surface,borderRadius:'18px',p:2.5,
    border:`1px solid ${IOS.separator}`,boxShadow:'0 1px 4px rgba(0,0,0,0.07)',...sx}}>
    {children}
  </Box>
);

const SectionTitle = ({icon,children,color=IOS.blue}) => (
  <Box sx={{display:'flex',alignItems:'center',gap:1,mb:2}}>
    <Box sx={{width:30,height:30,borderRadius:'9px',bgcolor:`${color}12`,display:'flex',alignItems:'center',justifyContent:'center',flexShrink:0}}>
      {icon}
    </Box>
    <Typography sx={{fontWeight:700,fontSize:'0.9rem',color:IOS.label}}>{children}</Typography>
  </Box>
);

const BulletItem = ({children}) => (
  <Box sx={{display:'flex',gap:1,mb:0.8,alignItems:'flex-start'}}>
    <Box sx={{width:5,height:5,borderRadius:'50%',bgcolor:IOS.blue,flexShrink:0,mt:'6px'}}/>
    <Typography sx={{fontSize:'0.8rem',color:IOS.label2,lineHeight:1.6}}>{children}</Typography>
  </Box>
);

const CotizarCertificado = () => {
  const navigate    = useNavigate();
  const user        = authService.getCurrentUser();
  const nf          = user?.nombreCompleto||user?.usuario||'';
  const handleLogout = () => { authService.logout(); navigate('/login'); };

  const [planSel,setPlanSel] = useState(1); // índice 0,1,2
  const [form,setForm]       = useState({nombre:'',email:'',telefono:'',ruc:'',mensaje:''});
  const [enviando,setEnviando] = useState(false);
  const [enviado,setEnviado]   = useState(false);

  const handleInput = e => setForm(f=>({...f,[e.target.name]:e.target.value}));

  const handleEnviar = async () => {
    if(!form.nombre||!form.email) return;
    setEnviando(true);
    // Aquí conectas con tu backend o mailto
    await new Promise(r=>setTimeout(r,1200));
    setEnviando(false);
    setEnviado(true);
  };

  const InputField = ({label,name,type='text',placeholder,textarea}) => (
    <Box>
      <Typography sx={{fontSize:'0.62rem',fontWeight:700,color:IOS.label2,
        textTransform:'uppercase',letterSpacing:'0.07em',mb:0.6}}>{label}</Typography>
      {textarea
        ?<textarea name={name} value={form[name]} onChange={handleInput} placeholder={placeholder} rows={4}
            style={{width:'100%',padding:'10px 12px',border:`1px solid ${IOS.separator}`,borderRadius:10,
              fontSize:'0.82rem',color:IOS.label,backgroundColor:IOS.bg,outline:'none',
              fontFamily:'inherit',resize:'vertical',boxSizing:'border-box',lineHeight:1.6}}
            onFocus={e=>e.target.style.borderColor=IOS.blue}
            onBlur={e=>e.target.style.borderColor=IOS.separator}/>
        :<input type={type} name={name} value={form[name]} onChange={handleInput} placeholder={placeholder}
            style={{width:'100%',height:38,padding:'0 12px',border:`1px solid ${IOS.separator}`,borderRadius:10,
              fontSize:'0.82rem',color:IOS.label,backgroundColor:IOS.bg,outline:'none',
              fontFamily:'inherit',boxSizing:'border-box'}}
            onFocus={e=>e.target.style.borderColor=IOS.blue}
            onBlur={e=>e.target.style.borderColor=IOS.separator}/>
      }
    </Box>
  );

  return (
    <Box sx={{minHeight:'100vh',bgcolor:IOS.bg}}>
      <HeaderIOS titulo="Certificado Digital" subtitulo="Economía"
        onHome={()=>navigate('/economia')} onLogout={handleLogout}
        nombreCompleto={nf} avatarLetra={nf.charAt(0).toUpperCase()}/>

      <Box sx={{maxWidth:1200,mx:'auto',px:{xs:2,sm:4},pt:3,pb:8}}>

        {/* Hero */}
        <Box sx={{bgcolor:IOS.blue,borderRadius:'22px',p:{xs:3,sm:4},mb:3,
          background:`linear-gradient(135deg, ${IOS.blue} 0%, ${IOS.purple} 100%)`,
          boxShadow:`0 8px 32px ${IOS.blue}40`,position:'relative',overflow:'hidden'}}>
          {/* Círculo decorativo */}
          <Box sx={{position:'absolute',right:-40,top:-40,width:200,height:200,borderRadius:'50%',bgcolor:'rgba(255,255,255,0.06)'}}/>
          <Box sx={{position:'absolute',right:40,bottom:-60,width:140,height:140,borderRadius:'50%',bgcolor:'rgba(255,255,255,0.04)'}}/>
          <Box sx={{position:'relative',zIndex:1}}>
            <Box sx={{display:'inline-flex',alignItems:'center',gap:0.8,px:1.2,py:0.4,
              bgcolor:'rgba(255,255,255,0.15)',borderRadius:'20px',mb:1.5}}>
              <Box sx={{width:6,height:6,borderRadius:'50%',bgcolor:'#6ee7b7'}}/>
              <Typography sx={{fontSize:'0.65rem',fontWeight:700,color:'white',letterSpacing:'0.06em'}}>ACREDITADA ANTE INDECOPI</Typography>
            </Box>
            <Typography sx={{fontSize:{xs:'1.3rem',sm:'1.7rem'},fontWeight:800,color:'white',lineHeight:1.2,mb:1}}>
              Certificado Digital para<br/>Factura Electrónica SUNAT
            </Typography>
            <Typography sx={{fontSize:'0.85rem',color:'rgba(255,255,255,0.75)',maxWidth:560,lineHeight:1.7}}>
              Firma documentos XML según estándares SUNAT. Válido para Facturas, Boletas, Notas de Crédito/Débito, Guías de Remisión, Percepciones, Retenciones y más.
            </Typography>
            <Box sx={{display:'flex',gap:1.5,mt:2,flexWrap:'wrap'}}>
              {['Entidad Certificación INDECOPI','Entidad Registro INDECOPI','Lista de Confianza'].map(t=>(
                <Box key={t} sx={{px:1.2,py:0.4,bgcolor:'rgba(255,255,255,0.12)',borderRadius:'20px',border:'1px solid rgba(255,255,255,0.2)'}}>
                  <Typography sx={{fontSize:'0.65rem',fontWeight:600,color:'white'}}>✓ {t}</Typography>
                </Box>
              ))}
            </Box>
          </Box>
        </Box>

        <Grid container spacing={2.5}>
          {/* Columna izquierda */}
          <Grid item xs={12} lg={7}>

            {/* Planes de precios */}
            <SectionCard sx={{mb:2.5}}>
              <SectionTitle color={IOS.blue} icon={<svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke={IOS.blue} strokeWidth="2" strokeLinecap="round"><line x1="12" y1="1" x2="12" y2="23"/><path d="M17 5H9.5a3.5 3.5 0 0 0 0 7h5a3.5 3.5 0 0 1 0 7H6"/></svg>}>
                Precios con IGV incluido
              </SectionTitle>
              <Box sx={{display:'flex',gap:1.5,flexDirection:{xs:'column',sm:'row'}}}>
                {PLANES.map((p,idx)=>(
                  <Box key={idx} onClick={()=>setPlanSel(idx)}
                    sx={{flex:1,borderRadius:'16px',p:2,cursor:'pointer',position:'relative',
                      border:`2px solid ${planSel===idx?IOS.blue:IOS.separator}`,
                      bgcolor:planSel===idx?`${IOS.blue}06`:IOS.bg,
                      transition:'all 0.2s',boxShadow:planSel===idx?`0 4px 16px ${IOS.blue}20`:'none',
                      '&:hover':{borderColor:IOS.blue,bgcolor:`${IOS.blue}04`}}}>
                    {p.badge&&(
                      <Box sx={{position:'absolute',top:-10,left:'50%',transform:'translateX(-50%)',
                        px:1.2,py:0.3,bgcolor:p.anios===2?IOS.orange:IOS.green,borderRadius:'20px'}}>
                        <Typography sx={{fontSize:'0.58rem',fontWeight:700,color:'white',whiteSpace:'nowrap'}}>{p.badge}</Typography>
                      </Box>
                    )}
                    <Typography sx={{fontSize:'0.65rem',fontWeight:700,color:IOS.label2,
                      textTransform:'uppercase',letterSpacing:'0.07em',mb:0.5}}>Vigencia</Typography>
                    <Typography sx={{fontSize:'1.4rem',fontWeight:800,color:planSel===idx?IOS.blue:IOS.label,lineHeight:1}}>
                      {p.anios} {p.anios===1?'año':'años'}
                    </Typography>
                    <Typography sx={{fontSize:'0.72rem',color:IOS.label2,textDecoration:'line-through',mt:1}}>
                      Antes: S/ {p.antes.toFixed(2)}
                    </Typography>
                    <Typography sx={{fontSize:'1.2rem',fontWeight:800,color:IOS.green,lineHeight:1.2}}>
                      S/ {p.ahora.toFixed(2)}
                    </Typography>
                    <Typography sx={{fontSize:'0.6rem',color:IOS.label2,mt:0.3}}>Incluye IGV</Typography>
                    {planSel===idx&&(
                      <Box sx={{mt:1.5,display:'flex',alignItems:'center',gap:0.5}}>
                        <Box sx={{width:14,height:14,borderRadius:'50%',bgcolor:IOS.blue,display:'flex',alignItems:'center',justifyContent:'center'}}>
                          <svg width="8" height="8" viewBox="0 0 24 24" fill="none" stroke="white" strokeWidth="3" strokeLinecap="round"><path d="M20 6L9 17l-5-5"/></svg>
                        </Box>
                        <Typography sx={{fontSize:'0.65rem',fontWeight:700,color:IOS.blue}}>Seleccionado</Typography>
                      </Box>
                    )}
                  </Box>
                ))}
              </Box>
              <Box sx={{mt:2,p:1.5,bgcolor:`${IOS.blue}06`,borderRadius:'12px',border:`1px solid ${IOS.blue}20`}}>
                <Typography sx={{fontSize:'0.76rem',color:IOS.label2,lineHeight:1.7}}>
                  Recomendamos contratar vigencias de <strong>2 ó 3 años</strong> para no realizar la validación de identidad tan pronto en la renovación y obtener un mejor precio.
                </Typography>
              </Box>
              <Box sx={{mt:1.5,p:1.5,bgcolor:IOS.bg,borderRadius:'12px',border:`1px solid ${IOS.separator}`,display:'flex',alignItems:'center',gap:1.5,flexWrap:'wrap'}}>
                <Typography sx={{fontSize:'0.72rem',color:IOS.label2,fontWeight:600}}>Métodos de pago:</Typography>
                {['BCP','VISA','MASTERCARD','AMEX','DINERS','PAYPAL'].map(m=>(
                  <Box key={m} sx={{px:0.8,py:0.2,bgcolor:IOS.surface,borderRadius:'6px',border:`1px solid ${IOS.separator}`}}>
                    <Typography sx={{fontSize:'0.62rem',fontWeight:700,color:IOS.label}}>{m}</Typography>
                  </Box>
                ))}
              </Box>
            </SectionCard>

            {/* Garantías */}
            <SectionCard sx={{mb:2.5}}>
              <SectionTitle color={IOS.green} icon={<svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke={IOS.green} strokeWidth="2" strokeLinecap="round"><path d="M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z"/></svg>}>
                Garantías
              </SectionTitle>
              <Box sx={{display:'flex',flexDirection:'column',gap:1.2}}>
                {[
                  ['Devolución de dinero','7 días hábiles desde el pago si no se descargó el certificado.',IOS.green],
                  ['Emisiones gratuitas ilimitadas','Por pérdida u olvido de contraseña durante toda la vigencia del certificado.',IOS.blue],
                  ['Factura electrónica','Emitimos comprobante a nombre de su empresa.',IOS.purple],
                ].map(([t,d,c])=>(
                  <Box key={t} sx={{display:'flex',gap:1.2,p:1.5,bgcolor:IOS.bg,borderRadius:'12px',border:`1px solid ${IOS.separator}`}}>
                    <Box sx={{width:8,height:8,borderRadius:'50%',bgcolor:c,flexShrink:0,mt:'4px'}}/>
                    <Box>
                      <Typography sx={{fontSize:'0.78rem',fontWeight:700,color:IOS.label,mb:0.2}}>{t}</Typography>
                      <Typography sx={{fontSize:'0.73rem',color:IOS.label2,lineHeight:1.6}}>{d}</Typography>
                    </Box>
                  </Box>
                ))}
              </Box>
            </SectionCard>

            {/* Requisitos */}
            <SectionCard sx={{mb:2.5}}>
              <SectionTitle color={IOS.orange} icon={<svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke={IOS.orange} strokeWidth="2" strokeLinecap="round"><path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z"/><polyline points="14 2 14 8 20 8"/></svg>}>
                Requisitos
              </SectionTitle>
              {REQUISITOS.map((r,i)=><BulletItem key={i}>{r}</BulletItem>)}
              <Box sx={{mt:1.5,p:1.5,bgcolor:`${IOS.blue}06`,borderRadius:'10px',border:`1px solid ${IOS.blue}20`}}>
                <Typography sx={{fontSize:'0.76rem',color:IOS.blue,fontWeight:600}}>
                  Ingresa a <strong>www.ardata.com.pe</strong> para solicitar el certificado digital.
                </Typography>
              </Box>
            </SectionCard>

            {/* Características */}
            <SectionCard sx={{mb:2.5}}>
              <SectionTitle color={IOS.purple} icon={<svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke={IOS.purple} strokeWidth="2" strokeLinecap="round"><circle cx="12" cy="12" r="10"/><path d="M12 8v4l3 3"/></svg>}>
                Características técnicas
              </SectionTitle>
              {CARACTERISTICAS.map((c,i)=><BulletItem key={i}>{c}</BulletItem>)}
            </SectionCard>

            {/* Tiempo entrega */}
            <SectionCard>
              <SectionTitle color={IOS.teal} icon={<svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke={IOS.teal} strokeWidth="2" strokeLinecap="round"><circle cx="12" cy="12" r="10"/><polyline points="12 6 12 12 16 14"/></svg>}>
                Tiempo de entrega
              </SectionTitle>
              <Typography sx={{fontSize:'0.8rem',color:IOS.label2,lineHeight:1.8}}>
                La entrega es <strong>INMEDIATA</strong> una vez validada la identidad y realizado el pago. La validación puede tomar minutos o hasta 2 días hábiles. El certificado se entrega a través de un ambiente seguro y cifrado — nadie, ni nosotros, tendrá acceso a él.
              </Typography>
            </SectionCard>

          </Grid>

          {/* Columna derecha — Formulario + Sobre Llama.pe */}
          <Grid item xs={12} lg={5}>
            <Box sx={{position:{lg:'sticky'},top:{lg:24}}}>

              {/* Formulario cotización */}
              <SectionCard sx={{mb:2.5}}>
                <SectionTitle color={IOS.blue} icon={<svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke={IOS.blue} strokeWidth="2" strokeLinecap="round"><path d="M20 14.66V20a2 2 0 0 1-2 2H4a2 2 0 0 1-2-2V6a2 2 0 0 1 2-2h5.34"/><polygon points="18 2 22 6 12 16 8 16 8 12 18 2"/></svg>}>
                  Solicitar cotización formal
                </SectionTitle>

                {enviado
                  ?<Box sx={{py:4,textAlign:'center'}}>
                    <Box sx={{width:56,height:56,borderRadius:'50%',bgcolor:'#EDFAF2',display:'flex',alignItems:'center',justifyContent:'center',mx:'auto',mb:2}}>
                      <svg width="26" height="26" viewBox="0 0 24 24" fill="none" stroke={IOS.green} strokeWidth="2.5" strokeLinecap="round"><path d="M20 6L9 17l-5-5"/></svg>
                    </Box>
                    <Typography sx={{fontWeight:700,color:IOS.label,mb:0.5}}>¡Solicitud enviada!</Typography>
                    <Typography sx={{fontSize:'0.8rem',color:IOS.label2}}>Nos comunicaremos contigo a la brevedad.</Typography>
                    <Box component="button" onClick={()=>setEnviado(false)}
                      sx={{mt:2,px:2,py:0.8,borderRadius:'10px',border:`1px solid ${IOS.separator}`,
                        bgcolor:IOS.bg,cursor:'pointer',fontSize:'0.78rem',color:IOS.label2}}>
                      Nueva solicitud
                    </Box>
                  </Box>
                  :<Box sx={{display:'flex',flexDirection:'column',gap:1.5}}>
                    {/* Plan seleccionado */}
                    <Box sx={{p:1.5,bgcolor:`${IOS.blue}06`,borderRadius:'12px',border:`1px solid ${IOS.blue}20`,
                      display:'flex',justifyContent:'space-between',alignItems:'center'}}>
                      <Typography sx={{fontSize:'0.75rem',fontWeight:600,color:IOS.label}}>
                        Plan seleccionado: {PLANES[planSel].anios} {PLANES[planSel].anios===1?'año':'años'}
                      </Typography>
                      <Typography sx={{fontSize:'0.9rem',fontWeight:800,color:IOS.blue}}>
                        S/ {PLANES[planSel].ahora.toFixed(2)}
                      </Typography>
                    </Box>

                    <InputField label="Nombre completo *" name="nombre" placeholder="Ingrese su nombre"/>
                    <InputField label="Correo electrónico *" name="email" type="email" placeholder="correo@empresa.com"/>
                    <InputField label="Teléfono" name="telefono" type="tel" placeholder="+51 999 999 999"/>
                    <InputField label="RUC (opcional)" name="ruc" placeholder="20XXXXXXXXX"/>
                    <InputField label="Información adicional" name="mensaje" placeholder="Alguna consulta o información relevante..." textarea/>

                    <Box component="button" onClick={handleEnviar}
                      disabled={!form.nombre||!form.email||enviando}
                      sx={{height:42,borderRadius:'12px',border:'none',
                        bgcolor:!form.nombre||!form.email?'#E5E5EA':IOS.blue,
                        cursor:!form.nombre||!form.email?'default':'pointer',
                        display:'flex',alignItems:'center',justifyContent:'center',gap:1,
                        boxShadow:form.nombre&&form.email?`0 4px 14px ${IOS.blue}40`:'none',
                        transition:'all 0.2s','&:hover':{filter:'brightness(0.92)'}}}>
                      {enviando
                        ?<Box sx={{width:16,height:16,borderRadius:'50%',border:'2px solid rgba(255,255,255,0.3)',borderTopColor:'white',animation:'spin 0.8s linear infinite','@keyframes spin':{'0%':{transform:'rotate(0deg)'},'100%':{transform:'rotate(360deg)'}}}}/>
                        :<svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="white" strokeWidth="2" strokeLinecap="round"><line x1="22" y1="2" x2="11" y2="13"/><polygon points="22 2 15 22 11 13 2 9 22 2"/></svg>
                      }
                      <Typography sx={{fontSize:'0.85rem',fontWeight:700,color:!form.nombre||!form.email?'#8E8E93':'white'}}>
                        {enviando?'Enviando...':'Enviar solicitud'}
                      </Typography>
                    </Box>
                  </Box>
                }
              </SectionCard>

              {/* Sobre Llama.pe */}
              <SectionCard>
                <Box sx={{display:'flex',alignItems:'center',gap:1.2,mb:1.5}}>
                  <Box sx={{width:36,height:36,borderRadius:'10px',
                    background:`linear-gradient(135deg, ${IOS.blue}, ${IOS.purple})`,
                    display:'flex',alignItems:'center',justifyContent:'center'}}>
                    <Typography sx={{fontSize:'0.9rem',fontWeight:900,color:'white'}}>AR</Typography>
                  </Box>
                  <Box>
                    <Typography sx={{fontWeight:800,fontSize:'0.9rem',color:IOS.label}}>ARDATA S.A.C.</Typography>
                    <Typography sx={{fontSize:'0.65rem',color:IOS.label2}}>Reseller de certificación.</Typography>
                  </Box>
                </Box>
                <Typography sx={{fontSize:'0.78rem',color:IOS.label2,lineHeight:1.8,mb:1.5}}>
                  Empresa peruana reseller de certificación, autorizada por INDECOPI y SUNAT. Ofrecemos soluciones informáticas escalables en la nube para instituciones del gobierno y empresas que necesitan comercio y comunicaciones digitales seguras.
                </Typography>
                <Box sx={{display:'flex',flexDirection:'column',gap:0.8}}>
                  {[
                    ['Entidad de Certificación','Emite certificados bajo estándares internacionales.'],
                    ['Entidad de Registro','Verifica y registra clientes: personas jurídicas y naturales.'],
                    ['Descuentos por volumen','Mayores descuentos para compras de múltiples certificados.'],
                  ].map(([t,d])=>(
                    <Box key={t} sx={{display:'flex',gap:1,p:1.2,bgcolor:IOS.bg,borderRadius:'10px',border:`1px solid ${IOS.separator}`}}>
                      <Box sx={{width:6,height:6,borderRadius:'50%',bgcolor:IOS.purple,flexShrink:0,mt:'5px'}}/>
                      <Box>
                        <Typography sx={{fontSize:'0.72rem',fontWeight:700,color:IOS.label}}>{t}</Typography>
                        <Typography sx={{fontSize:'0.68rem',color:IOS.label2}}>{d}</Typography>
                      </Box>
                    </Box>
                  ))}
                </Box>
              </SectionCard>

            </Box>
          </Grid>
        </Grid>
      </Box>
    </Box>
  );
};

export default CotizarCertificado;
